module.exports = __webpack_public_path__ + "static/cozinha-rj-77ae224a7a25a43a074479f28a22e27b.jpg";